<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';

const props = defineProps({
  modelValue: { type: String, default: '' },
});
const emit = defineEmits(['update:modelValue']);

const store = useStore();
const presets = ref([]);

onMounted(async () => {
  presets.value = await store.dispatch(
    'wgptCarShowroom/fetchBackgroundPresets'
  );

  // A background is required, so nobody should have to pick one to move on —
  // start on the first preset and let them change it.
  if (!props.modelValue && presets.value.length) {
    emit('update:modelValue', presets.value[0].id);
  }
});
</script>

<template>
  <div class="grid grid-cols-4 gap-2 px-3 py-3">
    <button
      v-for="preset in presets"
      :key="preset.id"
      type="button"
      class="relative overflow-hidden border rounded-lg aspect-video"
      :class="
        modelValue === preset.id
          ? 'border-n-blue-9 ring-1 ring-n-blue-9'
          : 'border-n-weak hover:border-n-slate-6'
      "
      :aria-label="
        $t(`WGPT_HUBPOST_CARS_SHOWROOM_SETUP.BACKGROUNDS.${preset.id}`)
      "
      :aria-pressed="modelValue === preset.id"
      @click="emit('update:modelValue', preset.id)"
    >
      <img
        :src="preset.url"
        :alt="$t(`WGPT_HUBPOST_CARS_SHOWROOM_SETUP.BACKGROUNDS.${preset.id}`)"
        class="object-cover w-full h-full"
      />
    </button>
  </div>
</template>
